import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';
import GetReceipt from '../components/GetReceipt';

const BookingDetails = () => {
    const { bookingId, categoryId } = useParams();
    const [bookingData, setBookingData] = useState([]);
    const [filteredBooking, setFilteredBooking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [popupUrl, setPopupUrl] = useState(null);
    const [receiptUrl, setReceiptUrl] = useState(null);
    const [popupDocUrl, setPopupDocUrl] = useState(null);
    const navigate = useNavigate();

    const openPopup = (url) => {
        setPopupUrl(url);
    };

    const closePopup = () => {
        setPopupUrl(null);
    };
    
    useEffect(() => {
        const fetchBookingDetails = async () => {
            setLoading(true);
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);
            formData.append('id', bookingId);
    
            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.bookingInfo}`,
                    data: formData
                });
    
                /*if (response.data && response.data.items.length > 0) {
                    setBookingData(response.data.items);
                    const booking = response.data.items.find(
                        (item) => item.stay_booking_id === Number(bookingId)
                    );
                    setFilteredBooking(booking || null);
                }*/
                if (response.data.status === 'ok') {
                    const booking = response.data.trip_item;
                    setFilteredBooking(booking);  
                    setReceiptUrl(
                        categoryId == 3
                            ? booking.stay_booking_cancel_receipt_url
                            : booking.stay_booking_receipt_url
                    );  
                    //console.log(response.data.trip_item);
                } else {
                    setError('No booking data found for this category.');
                }
            } catch (err) {
                setError('An error occurred while fetching booking data.');
            } finally {
                setLoading(false);
            }
        };

        fetchBookingDetails();
    }, [categoryId, bookingId]);

    const handleGuestProfile = () => {
        navigate(`/guest-details/${bookingId}/${categoryId}`);
    }

    const getFileType = (url) => {
        const ext = url.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return 'image';
        if (ext === 'pdf') return 'pdf';
        return 'unsupported';
    };

    const handleDownload = (url) => {
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = url.split('/').pop();
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            })
            .catch(error => {
                console.error('Error downloading the file:', error);
                const link = document.createElement('a');
                link.href = url;
                link.download = url.split('/').pop();
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
    };

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>No booking found for the provided ID.</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Booking Details</title>
                <meta name="description" content="" />
            </Helmet>

            <div className='booking-detail-section' style={{width:'600px'}}>
                {filteredBooking && (
                    <>
                        <h4 className='bd-title'>{filteredBooking.listing_title}, {filteredBooking.city_town}</h4>
                        <div className='category-img-section'>
                            <div className='ciso'>
                                <img src={filteredBooking.cover_photo} alt='' className='img-fluid w-100' />
                            </div>
                            <div className='cist'>
                                <img style={{height:'170px'}} src={filteredBooking.category_image_url} alt='' className='img-fluid w-100' />
                            </div>
                        </div>

                        <div class="check-container">
                            <div class="check-card cc-checkIn">
                                <p><img src={'/assets/img/icons/ws_checkin_checkout_icon_3.svg'} alt='' className='img-fluid cc-img' /> <strong>CHECK-IN</strong></p>
                                <p className='ccdbox'><img src={'/assets/img/icons/ws_date_time_icon.svg'} alt='' className='img-fluid cc-img' /> {filteredBooking.formatted_checkin_date}</p>
                                <p className='ccdbox'><img src={'/assets/img/icons/ws_date_time_icon.svg'} alt='' className='img-fluid cc-img' /> {filteredBooking.formatted_checkin_time}</p>
                            </div>

                            <div class="divider"></div>

                            <div class="check-card cc-checkOut">
                                <p><strong>CHECK-OUT</strong> <img src={'/assets/img/icons/ws_checkin_checkout_icon_3.svg'} alt='' className='img-fluid cc-img' /></p>
                                <p className='ccdbox'>{filteredBooking.formatted_checkout_date} <img src={'/assets/img/icons/ws_date_time_icon.svg'} alt='' className='img-fluid cc-img' /></p>
                                <p className='ccdbox'>{filteredBooking.formatted_checkout_time} <img src={'/assets/img/icons/ws_date_time_icon.svg'} alt='' className='img-fluid cc-img' /></p>
                            </div>
                        </div>

                        <span className='b-line'></span>

                        <div>
                            <h4 className='bd-title'>Reservation Details</h4>
                            <div className='bd-box'>
                                <strong>Guest info</strong>
                                <div className='bd-sub-box' onClick={() => handleGuestProfile()} style={{justifyContent:'space-between', cursor:'pointer'}}>
                                    <div className='bd-ssb-box'>
                                        <img src={'/assets/img/icons/ws_user_icon.svg'} alt="" className="bd-icon" />
                                        <p>{filteredBooking.customer_name}</p>
                                    </div>
                                    <div>
                                        <i class="fas fa-chevron-right"></i>
                                    </div>
                                </div>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/pointer_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.customer_phone}</p>
                                </div>
                            </div>
                            <hr></hr>
                            {filteredBooking.checkin_guest_name && filteredBooking.checkin_guest_name.length > 0 && (
                            <>
                                <div className="bd-box">
                                    <strong>Check-in User Details</strong>
                                    {filteredBooking.checkin_guest_name.map((guest, index) => (
                                        <div key={index} className="bd-sub-box" style={{justifyContent:'space-between'}}>
                                            <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                                                <img
                                                    src="/assets/img/icons/pointer_icon.svg"
                                                    alt=""
                                                    className="bd-icon"
                                                />
                                                <p>{guest.guest_name}</p>
                                            </div>
                                            <div className='gipds'>
                                                {guest.identity_proof ? (
                                                    <span onClick={() => setPopupDocUrl(guest.identity_proof)}>View Doc</span>
                                                ) : (
                                                    <span>No Doc</span>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                    {filteredBooking.actual_checkin_datetime && (
                                    <div className='bd-sub-box'>
                                        <img src={'/assets/img/icons/pointer_icon.svg'} alt="" className="bd-icon" />
                                        <div>
                                            <span>CHECKIN TIME - </span><span>{filteredBooking.actual_checkin_datetime}</span>
                                        </div>
                                    </div>
                                    )}
                                    {filteredBooking.actual_checkout_datetime && (
                                    <div className='bd-sub-box'>
                                        <img src={'/assets/img/icons/pointer_icon.svg'} alt="" className="bd-icon" />
                                        <div>
                                            <span>CHECKOUT TIME - </span><span>{filteredBooking.actual_checkout_datetime}</span>
                                        </div>
                                    </div>
                                    )}
                                </div>
                                <hr />
                            </>
                            )}
                            <div className='bd-box'>
                                <strong>Confrimation code</strong>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/pointer_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.confirmation_code}</p>
                                </div>
                            </div>
                            <hr></hr>
                            <div className='doc-box' onClick={() => openPopup(receiptUrl)}>
                                <div>
                                    <span>Get receipt</span>
                                </div>
                                <div>
                                    <i class="fas fa-chevron-right"></i>
                                </div>
                            </div>
                        </div>

                        <span className='b-line'></span>

                        <div>
                            <h4 className='bd-title'>Booked for</h4>
                            <div className='bd-guest-data'>
                                <div className='cat-pointer'>
                                    <img src={'/assets/img/icons/ws_user_icon.svg'} alt="Profile" className="bd-icon" />
                                    <span>{filteredBooking.guest_info.booking_for}</span>
                                </div>
                                <div className='cat-pointer'>
                                    <img src={'/assets/img/icons/ws_user_icon.svg'} alt="Profile" className="bd-icon" />
                                    <span>{filteredBooking.guest_info.title} {filteredBooking.guest_info.first_name} {filteredBooking.guest_info.last_name}</span>
                                </div>
                                <div className='cat-pointer'>
                                    <img src={'/assets/img/icons/common_point_icon.png'} alt="Profile" className="bd-icon" />
                                    <span>{filteredBooking.guest_info.email}</span>
                                </div>
                                <div className='cat-pointer m-0'>
                                    <img src={'/assets/img/icons/common_point_icon.png'} alt="Profile" className="bd-icon" />
                                    <span>{filteredBooking.guest_info.contact_no}</span>
                                </div>
                            </div>
                        </div>

                        <span className='b-line'></span>

                        <div>
                            <h4 className='bd-title'>Payment info</h4>
                            <div className='bd-box'>
                                <strong>Amount paid</strong>
                                <div className='bd-sub-box'>
                                    <img src={'/assets/img/icons/pointer_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.priceItem.currency_symbol} {filteredBooking.priceItem.total}</p>
                                </div>
                            </div>
                            <hr></hr>
                            <div className='doc-box' onClick={() => openPopup(filteredBooking.stay_booking_payment_receipt_url)}>
                                <div>
                                    <span>Get receipt</span>
                                </div>
                                <div>
                                    <i class="fas fa-chevron-right"></i>
                                </div>
                            </div>
                        </div>

                        <span className='b-line'></span>

                        <div>
                            <h4 className='bd-title'>Cancellation policy</h4>
                            <p> This reservation is non-refundable.</p>
                        </div>

                        {filteredBooking.cancelled_on_date && (
                            <>
                            <span className='b-line'></span>
                            <div>
                                <p>{filteredBooking.cancelled_on_date}</p>
                            </div>
                            </>
                        )}
                    </>
                )}
            </div>

            <GetReceipt url={popupUrl} onClose={closePopup} />

            {popupDocUrl && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <div className="euc-close" onClick={() => setPopupDocUrl(null)}>
                            <img src={'/assets/img/icons/popup_close.png'} className="img-fluid" alt="" />
                        </div>

                        {getFileType(popupDocUrl) === 'image' && (
                            <img
                                src={popupDocUrl}
                                alt="Document Preview"
                                style={{ maxWidth: '100%', maxHeight: '80vh' }}
                            />
                        )}

                        {getFileType(popupDocUrl) === 'pdf' && (
                            <iframe
                                src={popupDocUrl}
                                title="PDF Preview"
                                width="100%"
                                height="500px"
                                style={{ border: 'none' }}
                            />
                        )}

                        {getFileType(popupDocUrl) === 'unsupported' && (
                            <p>Unsupported file format</p>
                        )}

                        <div className='co-host-box'>
                            <button className='acc-btn-txt' onClick={() => handleDownload(popupDocUrl)} style={{ background: 'transparent', border:'none', textTransform:'uppercase' }}>
                                Download
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default BookingDetails;
